import { useTranslation } from 'react-i18next';
import { SortOption } from '@anytag/shared-types';
import { Order, PostListSortFieldV3 } from '@anytag/graphql';
import { Filter } from '@anytag/shared-molecules';
import { usePostsFilter } from './hooks';
import { BasicFilter } from './BasicFilter';

export const PostsFilter = () => {
  const { t } = useTranslation();
  const { filter, setFilterForm } = usePostsFilter();

  const sortOptions: SortOption<PostListSortFieldV3>[] = [
    { field: PostListSortFieldV3.ENGAGEMENT_RATE, label: t('ER (ASC)'), order: Order.ASC },
    { field: PostListSortFieldV3.ENGAGEMENT_RATE, label: t('ER (DESC)'), order: Order.DESC },
    { field: PostListSortFieldV3.FOLLOWERS, label: t('Follower (ASC)'), order: Order.ASC },
    { field: PostListSortFieldV3.FOLLOWERS, label: t('Follower (DESC)'), order: Order.DESC },
    { field: PostListSortFieldV3.POST_DATE, label: t('Post Date (ASC)'), order: Order.ASC },
    { field: PostListSortFieldV3.POST_DATE, label: t('Post Date (DESC)'), order: Order.DESC },
    { field: PostListSortFieldV3.RELEVANT, label: t('Relevant (DESC)'), order: Order.DESC }
  ].map((option) => ({ ...option, value: `${option.field}-${option.order}` }));
  const selectedSortOption = sortOptions.find((o) => o.field === filter.field && o.order === filter.order);

  return (
    <Filter.Provider onSubmit={setFilterForm} values={{ ...filter, sort: selectedSortOption?.value || '' }}>
      <BasicFilter sortOptions={sortOptions} />
    </Filter.Provider>
  );
};

export * from './schemaTypes';
export * from './hooks';
